export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PasswordResetConfirm.vue?vue&type=template&id=921863ae"


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/confirpassreset/PasswordResetConfirm.vue?vue&type=template&id=921863ae
// module id = TeKV
// module chunks = 41